module.exports = __webpack_public_path__ + "static/media/IconoChecklist.7a559865.svg";